import React, { Component } from 'react';
var DefaultLayout = require('./common/layout');
import DropDown from './common/dropDown';
import Datepicker from './common/datepicker';
import '../public/less/chat.less';
import SocketIOClient from 'socket.io-client';

var doctorID = 219;
var patientID = 201;
var doctorName = "doctor";
var userName = "user";

var lastTimeTyping;

module.exports = class chat extends Component {
    constructor(props) {
        super(props);

        this.state = {
            message: '',
            chatMessages: [],
            typing: "",
            users: ""
        };

        this.messageChange = this.messageChange.bind(this);
        this.sendMessage = this.sendMessage.bind(this);

        this.socket = SocketIOClient('http://127.0.0.1:3000/');

        // Connected, let's sign-up for to receive messages for this room
        this.socket.emit('room', patientID);
    }

    addChatMessage(data) {
        var chatMessages = this.state.chatMessages;
        chatMessages.push(data);
        this.setState({ chatMessages: chatMessages });

        this._messages.updateMessages(chatMessages);
    }

    componentDidMount() {
        this.socket.emit('patient joined', patientID, userName);

        var _this = this;

        this.socket.on('new message', function (data) {
            _this.addChatMessage(data);
        });

        this.socket.on('doctor joined', function (data) {
            _this.setState({
                users: data.users
            });
            _this.addChatMessage(data);
        });

        this.socket.on('patient joined', function (data) {
            _this.setState({
                users: data.users
            });
            _this.addChatMessage(data);
        });

        this.socket.on('user left', function (data) {
            _this.setState({
                users: data.users
            });
            _this.addChatMessage(data);
        });

        this.socket.on('typing', function (data) {
            if (data.userID != doctorID)
                _this.addTypingMessage(data);
        });
        this.socket.on('stop typing', function (data) {
            _this.removeTypingMessage(data);
        });
    }

    addTypingMessage(data) {
        this.setState({
            typing: data.userName + " is typing..."
        });
    }

    removeTypingMessage(data) {
        this.setState({
            typing: ""
        });
    }

    sendMessage(e) {
        if (e.keyCode == 13) {
            this.socket.emit('new message', this.state.message);
            this.setState({ message: '' });
        }
    }

    messageChange(e) {
        this.socket.emit('typing');
        lastTimeTyping = new Date().getTime();

        var _this = this;
        setTimeout(function () { _this.removeTyping() }, 3000);
        this.setState({
            message: e.target.value
        });
    }

    removeTyping() {
        var currentDate = new Date().getTime();
        console.log("remove typing?" + (currentDate - lastTimeTyping) / 3600);
        if ((currentDate - lastTimeTyping) >= 3000) {
            this.socket.emit('stop typing', this.state.message);
        }
    }

    render() {
        return (
            <div className="container">
                <h3>Chat</h3>
                <h5>Current users: {this.state.users}</h5>
                <div className="panel panel-primary">
                    <div className="panel">
                        <div className="panel-body" id="panel-body">
                            <MessagesClass value={this.state.chatMessages} ref={(messages) => { this._messages = messages; }} />
                        </div>
                        <div className="panel-footer">
                            <div className="input-group">
                                <input id="btn-input" type="text" className="form-control input-sm" placeholder="Type your message here..." onKeyDown={this.sendMessage} onChange={this.messageChange} value={this.state.message} />
                            </div>
                            <div className='userTyping'>
                                {this.state.typing}
                            </div>
                        </div>
                    </div>
                </div>
            </div>



        )
    }
};

class MessagesClass extends Component {
    constructor(props) {
        super(props);

        this.state = {
            messages: this.props.value ? this.props.value : []
        };

        this.updateMessages = this.updateMessages.bind(this);
    }

    updateMessages(messages) {
        this.setState({
            messages: messages
        });

        this.setScroll();
    }

    setScroll() {
        var elem = document.getElementById('panel-body');
        elem.scrollTop = elem.scrollHeight;
    }

    render() {
        var messages = [];
        for (var i = 0; i < this.state.messages.length; i++) {
            messages.push(<MessageLine userName={this.state.messages[i].username} key={i} message={this.state.messages[i].message} userType={this.state.messages[i].userType} timeStamp={this.state.messages[i].timeStamp} />);
        }

        return (
            <ul className="chat">
                {messages}
            </ul>
        )
    }
}


class MessageLine extends Component {
    constructor(props) {
        super(props);

        this.state = {
            color: this.props.userType == "doctor" ? 'rgb(74, 232, 196' : 'rgb(83, 93, 224)',
            timeStamp: this.props.timeStamp,
            timeElapsed: ""
        }

        this.calculateTime = this.calculateTime.bind(this);
    }

    componentDidMount() {
        this.calculateTime();
        this.interval = setInterval(this.calculateTime, 1000);
    }

    calculateTime() {
        var curTime = new Date();
        var timeStamp = new Date(this.state.timeStamp);

        var toMinutes = 1000 * 60;
        var toHours = toMinutes * 60;
        var toDays = toHours * 24;
        var toWeeks = toDays * 7;

        var timeElapsed;
        var diff = curTime - timeStamp;
        if (diff / toWeeks > 1) {
            timeElapsed = Math.floor(diff / toWeeks) + " weeks ago";
        }
        else if (diff / toDays > 1) {
            timeElapsed = Math.floor(diff / toDays) + " days ago";;
        }
        else if (diff / toHours > 1) {
            timeElapsed = Math.floor(diff / toHours) + " hours ago";;
        }
        else if (diff / toMinutes > 1) {
            timeElapsed = Math.floor(diff / toMinutes) + " min ago";;
        }
        else {
            timeElapsed = "just now";
        }

        this.setState({ timeElapsed: timeElapsed });
    }


    render() {
        var className = this.props.userType == "doctor" ? "left clearfix" : "right clearfix";
        var imageClassName = this.props.userType == "doctor" ? "pull-left chat-img" : "pull-right chat-img";

        return (
            <li className={className}>
                <div className="chat-body clearfix">
                    <div className="header">
                        <strong className="primary-font">{this.props.userName}</strong>
                        <small className="pull-right text-muted">
                            <span className="glyphicon glyphicon-time"></span>{this.state.timeElapsed}
                        </small>
                    </div>
                    <p>
                        {this.props.message}
                    </p>
                </div>
            </li>

        )
    }
}



// WEBPACK FOOTER //
// ./modules/chatFixedPatient.jsx